import { useMemo } from 'react';
import { useAgentModelSupportMatrix } from '@reflex/ui/client/hooks';
import { pickFlowAgentType } from '../shared/agent-type-resolution.js';

/**
 * The agent type a flow node will actually launch with, given what it pins.
 *
 * Applies the runtime's own rule (`shared/agent-type-resolution.ts`) against
 * the org's model-support matrix, so the editor names the agent the run uses
 * instead of assuming the constant fallback. While the matrix loads this
 * returns that fallback and re-resolves once it lands.
 */
export function useFlowRuntimeAgentType(
  pinned: string | null | undefined,
  model: string | null | undefined,
): string {
  const { data } = useAgentModelSupportMatrix();
  return useMemo(() => pickFlowAgentType({ pinned, model, catalog: data }), [data, pinned, model]);
}
